// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ShopSupplierResourceViewModel from '../../../../viewModel/resource/ShopSupplierResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ShopSupplierResourceListResultViewModel from '../../../../viewModel/resource/ShopSupplierResourceListResultViewModel';
import ShopSupplierResourceListResultDTO from '../../dto/resource/ShopSupplierResourceListResultDTO';

export default abstract class ShopSupplierResourceListResultModel extends BaseModel<ShopSupplierResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, ShopSupplierResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
